import { loadLocaleMessages } from ".";

// 初始化语言
export function initI18n(i18n, defaultLocale = 'en-us') {
  // 从本地存储获取保存的语言偏好，或使用默认语言
  const savedLocale = localStorage.getItem('lang') || defaultLocale;

  try {
    // 加载语言文件
    loadLocaleMessages(savedLocale);
    i18n.global.locale = savedLocale;
    return savedLocale;
  } catch (error) {
    console.error('Failed to initialize language:', error);
    // 回退到默认语言
    loadLocaleMessages(defaultLocale);
    i18n.global.locale = defaultLocale;
    return defaultLocale;
  }
}

// 切换语言
export function setI18nLanguage(i18n, locale) {
  try {
    debugger
    loadLocaleMessages(locale);
    i18n.global.locale = locale;
    localStorage.setItem('lang', locale);
    return true;
  } catch (error) {
    console.error('Failed to change language:', error);
    return false;
  }
}